// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"965b710d","688":"e4fae886"}[chunkId] + ".chunk.js";
};